import { IFirestorePromo } from '@/src/modules/firestore/promos/promos.interface';
import { IFirestoreOffer } from '@/src/modules/firestore/offers/offers.interface';
import { ILocaleType } from '@/src/types';

export interface IDiscount {
  amount: number;
  volume: number;
}

export const applyDiscount = (
  offer: IFirestoreOffer,
  promo?: IFirestorePromo
): IDiscount => {
  let amount = offer.basePriceEuros;
  let volume = offer.volume;
  if (promo?.type === 'extraData') {
    volume += promo.value;
  } else if (promo?.type === 'flatDiscount') {
    amount -= promo.value;
  } else if (promo?.type === 'percentDiscount') {
    amount = amount - (amount / 100) * promo.value;
  }

  return {
    amount,
    volume,
  };
};

export const compareDiscounts = (
  baseDiscount: IDiscount,
  newDiscount: IDiscount
) => {
  const { amount: baseAmount, volume: baseVolume } = baseDiscount;
  const { amount: newAmount, volume: newVolume } = newDiscount;

  if (newAmount !== baseAmount && newVolume === baseVolume) {
    return newAmount < baseAmount;
  }

  if (newVolume !== baseVolume && newAmount === baseAmount) {
    return newVolume > baseVolume;
  }

  return null;
};

export const formatPrice = (price: number, locale: ILocaleType) => {
  let basePrice = (price / 100).toFixed(2);

  if (locale.priceSeparator === ',') {
    basePrice = basePrice.replace('.', ',');
  }

  if (locale.currencyPlace === 'before') {
    basePrice = '€' + basePrice;
  } else {
    basePrice = basePrice + '€';
  }
  return basePrice;
};
